import React from 'react';

import { TabLoader, TabConfig, addTab, removeAll } from 'wdna-components/lib/tabs';

const Graphs: React.LazyExoticComponent<any> = React.lazy(() => import('../components/Graphs'));

export default class Loader extends TabLoader {
  /* Override tab loader method */
  public loadTab = (tabId?: string | number): void => {
    const access: boolean = true;
    if (access) {
      window.store.dispatch(removeAll());

      const tabData: TabConfig = {
        id: String(tabId || window.getStr()),
        active: true,
        title: 'Sensors | Graphs',
        component: Graphs,
        props: {
          report: 'SENSOR_GRAPHS',
          title: 'Graphs',
        },
      };

      window.store.dispatch(addTab(tabData));
    }
  };
}
